module.exports = __webpack_public_path__ + "img/品牌强国.cc943c0c.jpg";